import SocialLogin from "../components/auth/OAuth/SocialLogin";

const KakaoOAuth = (props) => {
  return (
    <>
      <SocialLogin type='kakao' />
    </>
  );
};

export default KakaoOAuth;
